import { Col, Modal, Button } from "react-bootstrap";
import { useState } from "react";
import { T } from "react-translator-component";

const PayButton = ({ balance }) => {
    const [showModal, setShowModal] = useState(false)

    return (
        <Col className="p-2">
            <div>
                <Button
                    size={"lg"}
                    disabled={balance && balance.payments?.total > 0}
                    variant={"success"}
                    type={"button"}
                    className="text-uppercase w-100 btn-lg"
                    onClick={() => { setShowModal(true) }}
                >
                    {T("checkout.pay_now")}
                </Button>
            </div>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
            >
                <div className="text-center mb-2 p-4 text-uppercase">
                    This feature will be available soon!
                </div>
            </Modal>
        </Col>
    )
}

export default PayButton